import React, { useState, useRef, useEffect, useCallback, useMemo } from 'react';

const TeeCard = React.memo(({ book, onBookSelect, isBookingAllowed }) => {
    const [isClicking, setIsClicking] = useState(false);
    const clickTimeoutRef = useRef(null);

    useEffect(() => {
        return () => {
            if (clickTimeoutRef.current) {
                clearTimeout(clickTimeoutRef.current);
            }
        };
    }, []);

    const statusInfo = useMemo(() => {
        const isAvailable = book.Status === "Available" || book.Status === null;
        const isBooked = book.Status === "Booked";
        const isPending = book.Status === "Pending";
        const isRemaining = book.Status === "Remaining";
        
        let displayText, iconClass, isClickable;
        
        if (isAvailable) {
            displayText = "Available";
            iconClass = "fa fa-check-circle-o text-green fa-lg margin-lr5";
            isClickable = true;
        } else if (isRemaining) {
            displayText = book.DisplayStatus;
            iconClass = "fa fa-check-circle-o text-green fa-lg margin-lr5";
            isClickable = true;
        } else if (isPending || isBooked) {
            displayText = book.Status;
            iconClass = "fa fa-times-circle-o fa-lg margin-lr5";
            isClickable = false;
        } else {
            displayText = "Not Available";
            iconClass = "fa fa-times-circle-o fa-lg margin-lr5";
            isClickable = false;
        }

        // Determine header class
        let headerClass;
        if (isPending) {
            headerClass = 'slot-card-header-pending';
        } else if(isRemaining || isAvailable || book.Status == null){
            headerClass = 'slot-card-header';
        } else {
            headerClass = 'slot-card-header-blur';
        }

        return {
            displayText,
            iconClass,
            headerClass,
            isClickable,
            isBooked,
            isPending,
            isRemaining
        };
    }, [book.Status, book.DisplayStatus]);

    const handleBookSelect = useCallback(() => {
        if (isClicking || !statusInfo.isClickable || isBookingAllowed ) {
            return;
        }
        
        setIsClicking(true);
        onBookSelect(book);
        
        if (clickTimeoutRef.current) {
            clearTimeout(clickTimeoutRef.current);
        }
        
        clickTimeoutRef.current = setTimeout(() => {
            setIsClicking(false);
        }, 1000);
    }, [isClicking, statusInfo.isClickable, isBookingAllowed, onBookSelect, book]);

    const cardClasses = useMemo(() => {
        const baseClass = 'slot-card';
        const shouldDisable = statusInfo.isBooked || isBookingAllowed || isClicking || !statusInfo.isClickable;
        return shouldDisable ? `${baseClass} disableClick` : baseClass;
    }, [statusInfo.isBooked, statusInfo.isClickable, isBookingAllowed, isClicking]);

    return (
        <div className="col-md-6 col-sm-6 col-lg-3 padding-0">
            <div 
                className={cardClasses}
                onClick={handleBookSelect}
                role="button"
                tabIndex={statusInfo.isClickable ? 0 : -1}
                aria-disabled={!statusInfo.isClickable || isBookingAllowed}
            >
                {book.DiscountLabel && (
                    <span className="slot-card-discount-badge" title="Dynamic Pricing discount available for this slot">
                        {/* <i className="fa fa-tag" aria-hidden="true"></i> */}
                        {book.DiscountLabel}
                    </span>
                )}
                <div className={statusInfo.headerClass}>
                    <div className="row row-flex-warp margin-0">
                        <div className="col-xs-12 padding-0">
                            <b>{book.Slot.split(':')[0].length === 1 ? '\u00A0' + book.Slot + '\u00A0' : book.Slot}</b>
                        </div>
                    </div>
                </div>

                <div className="slot-card-available-wrapper">
                    <div className="slot-card-available">
                        <div>
                            <span>{statusInfo.displayText}</span>
                            <i className={statusInfo.iconClass} aria-hidden="true"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
});

TeeCard.displayName = 'TeeCard';

export default TeeCard;